import React, { useState, useEffect } from "react";
import "../home/Home.css";
import {
  registerOrLogin,
  userResendOtp,
  forgotPassword,
  emailVerifyOtp,
  resenOtp,
  resetPassword,
  userLogin,
  userRegister,
  userSendLoginOtp,
  userVerifyLoginOtp,
} from "../services/authService";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../redux/slices/authSlice";
import { Modal } from "react-bootstrap";
import { saveToken, saveUserData } from "../utils/storage";
import { useNavigate } from "react-router-dom";

import { userVerifyEmailOtp } from "../services/authService";

function AuthModal({ show, onClose, setShowUserLogin }) {
  const [step, setStep] = useState(2);
  const [showPassword, setShowPassword] = useState(false);
  const [emailOtp, setEmailOtp] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [loginOtpSent, setLoginOtpSent] = useState(false);

  const [resendTimer, setResendTimer] = useState(120);
  const [resending, setResending] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    emailid: "",
    phonenumber: "",
    fullname: "",
    password: "",
    newPassword: "",
    confirmPassword: "",
  });

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleChangeButton = () => {
    setFormData({ ...formData, fullname: "", phonenumber: "", password: "" });
    setStep(1);
  };

  const handleIdentifierSubmit = async () => {
    try {
      setLoading(true);
      const payload = { emailid: formData.emailid };
      const response = await registerOrLogin(payload);
      console.log("identifire response", response);
      if (response.data.status === "otp_required") {
        setStep(4);
        return;
      }
    } catch (err) {
      console.log("error n identifire", err);
      console.log("err in handleIdentifierSubmit", err.response);
      if (err?.response?.data?.userExists === true) {
        setStep(2);
      } else if (err?.response?.data?.userExists === false) {
        setStep(3);
      } else {
        console.log("error in user login or register");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async () => {
    try {
      setLoading(true);
      const payload = {
        emailid: formData.emailid,
        password: formData.password,
      };
      const response = await userLogin(payload);

      if (response.data.status === "otp_required") {
        setStep(4);
        return;
      }
      if (response.data.status === true) {
        dispatch(
          loginSuccess({
            user: response.data.user,
            token: response.data.token,
          }),
        );
        saveUserInfo(response);
        setShowUserLogin(false);
      }
    } catch (err) {
      alert(err.response.data.message);
      console.log("err in login", err.response);
    } finally {
      setLoading(false);
    }
  };

  const handleSendLoginOtp = async () => {
    try {
      setLoading(true);
console.log("calling send otp api");
      const response = await userSendLoginOtp({
        emailid: formData.emailid,
      });
      console.log("resp of user send login otp",response);

      if (response.data.status === "otp_sent") {
        setLoginOtpSent(true);
        setMessage("OTP sent to your email");
        setResendTimer(120);
      }
    } catch (err) {
      console.log("err of send otp",err);
      alert(err.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyLoginOtp = async () => {
    try {
      setLoading(true);

      const response = await userVerifyLoginOtp({
        emailid: formData.emailid,
        otp: emailOtp,
      });

      if (response.data.status === true) {
        dispatch(
          loginSuccess({
            user: response.data.user,
            token: response.data.token,
          }),
        );

        saveUserInfo(response);
        setShowUserLogin(false);
      }
    } catch (err) {
      alert(err.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async () => {
    try {
      setLoading(true);
      const response = await userRegister(formData);

      if (response?.data?.status === "otp_required") {
        setMessage(response.data.message);
        setStep(4);
      }
    } catch (err) {
      alert(err.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  const verifyEmailOtp = async () => {
    try {
      setLoading(true);
      const payload = {
        emailid: formData.emailid,
        otp: emailOtp,
      };
      console.log("payload before senign api", payload);
      const res = await userVerifyEmailOtp(payload);

      if (res.data.status === true) {
        dispatch(loginSuccess({ user: res.data.user, token: res.data.token }));
        saveUserInfo(res);
        setShowUserLogin(false);
      }
    } catch (err) {
      console.log("error in verify otp", err.response);
      alert(err.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  // forgate passwor start.........

  const VerifyforgotPassword = async () => {
    try {
      console.log("forgot calling api");
      setLoading(true);
      const payload = {
        email: formData.emailid,
      };
      console.log("payload before senign api", payload);
      const res = await forgotPassword(payload);
      console.log("resp of forgot password", res);
      setStep(6);
      // if (res.data.status === true) {
      //   dispatch(loginSuccess({ user: res.data.user, token: res.data.token }));
      //   saveUserInfo(res);
      //   setShowUserLogin(false);
      // }
    } catch (err) {
      console.log("error in forgot pasrd otp", err.response);
      alert(err.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  const VerifyforgotEmailOtp = async () => {
    try {
      console.log("forgot otp api");
      setLoading(true);
      const payload = {
        email: formData.emailid,
        otp: emailOtp,
      };
      console.log("payload before senign otp api", payload);
      const res = await emailVerifyOtp(payload);
      console.log("resp of verify otp", res);
      setStep(7);
    } catch (err) {
      console.log("error in verify otp", err.response);
      alert(err.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  const ResendforgotOtp = async () => {
    try {
      console.log("Resend otp api");
      setLoading(true);
      const payload = {
        email: formData.emailid,
      };
      console.log(" Resend payload before senign api", payload);
      const res = await resenOtp(payload);
      console.log("resp Rsend otp", res);
    } catch (err) {
      console.log("error in Resend otp", err.response);
      alert(err.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  const ResetUserPassword = async () => {
    try {
      console.log("Rset password");
      setLoading(true);
      const payload = {
        email: formData.emailid,
        newPassword: formData.newPassword,
        confirmPassword: formData.confirmPassword,
      };
      console.log("payload reset password", payload);
      const res = await resetPassword(payload);
      console.log("resp of verify otp", res);
      setStep(2);
    } catch (err) {
      console.log("error in verify otp", err.response);
      alert(err.response.data.message);
    } finally {
      setLoading(false);
    }
  };
  //  end -----------------
  const handleResendOtp = async () => {
    try {
      setResending(true);
      await userResendOtp({ emailid: formData.emailid });

      setResendTimer(120); // reset timer
      alert("OTP resent successfully");
    } catch (err) {
      alert(err.response?.data?.message || "Failed to resend OTP");
    } finally {
      setResending(false);
    }
  };

  const saveUserInfo = (response) => {
    const now = Date.now();
    saveUserData("safarix_user", response.data.user);

    saveToken("safarix_token", response.data.token);
    saveToken("safarix_refreshtoken", response.data.refreshToken);

    // ✅ ADD THIS
    saveUserData("safarix_login_time", now);
   };

  useEffect(() => {
    if (step === 4 || step === 6 || step === 7) {
      setResendTimer(120);
      // setResendTimer(10);

      const interval = setInterval(() => {
        setResendTimer((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [step]);

  return (
    <>
      <Modal
        show={show}
        // onHide={() => setShowUserLogin(false)}
        onHide={() => {
          setShowUserLogin(false);
          setLoginOtpSent(false);
          setEmailOtp("");
        }}
        backdrop="static"
        keyboard={false}
        centered
        className="login-modal"
      >
        {/* Modal Header */}
        <Modal.Header closeButton>
          {step === 2 && <Modal.Title>Login</Modal.Title>}
          {step === 3 && <Modal.Title>Create account</Modal.Title>}
          {step === 4 && <Modal.Title>Verify OTP</Modal.Title>}
          {step === 5 && <Modal.Title>Enter Email</Modal.Title>}
          {step === 6 && <Modal.Title>Verify Email Otp</Modal.Title>}
          {step === 7 && <Modal.Title>Reset Password</Modal.Title>}
        </Modal.Header>

        {/* Modal Body */}
        <Modal.Body>
         

          {step === 2 && (
            <>
              <div className="mb-3">
                <div className="input-wrapper">
                  <input
                    type="email"
                    placeholder="Email address"
                    name="emailid"
                    value={formData.emailid}
                     disabled={loginOtpSent}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* SEND OTP BUTTON */}
             
           <div className="mb-3">
  {!loginOtpSent ? (
    <button
      className="explore-btn"
      disabled={!formData.emailid || loading}
      onClick={handleSendLoginOtp}
    >
      {loading ? "Processing..." : "Send OTP"}
    </button>
  ) : (
    <button
      type="button"
  className="btn btn-link p-0"
      onClick={() => {
        setLoginOtpSent(false);
        setEmailOtp("");
      }}
    >
      Use different email
    </button>
  )}
</div>

              {/* OTP FIELD */}
              {loginOtpSent && (
                <>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter 6-digit OTP"
                      value={emailOtp}
                      onChange={(e) => setEmailOtp(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <button
                      className="explore-btn"
                      disabled={emailOtp.length !== 6 || loading}
                      onClick={handleVerifyLoginOtp}
                    >
                      {loading ? "processing..." : "Verify & Login"}
                    </button>
                  </div>
                </>
              )}

              <div className="row">
                <div className="col">
                  <button
                    className="btn btn-link p-0 small text-muted"
                    onClick={() => setStep(5)}
                  >
                    Forgot Your Password?
                  </button>
                </div>
                <div className="col text-end">
                  <button
                    className="btn btn-link p-0 small text-muted"
                    onClick={() => setStep(3)}
                  >
                    New User? Register
                  </button>
                </div>
              </div>
            </>
          )}

          {step === 3 && (
            <>
              <div className="mb-3">
                <div className="input-wrapper">
                  <input
                    type="email"
                    placeholder="Email address"
                    name="emailid"
                    value={formData.emailid}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="mb-3">
                <div className="input-wrapper">
                  <input
                    type="text"
                    placeholder="Full name"
                    name="fullname"
                    value={formData.fullname}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="mb-3">
                <div className="input-wrapper">
                  <input
                    type="text"
                    placeholder="Phone number"
                    name="phonenumber"
                    value={formData.phonenumber}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="mb-3 position-relative">
                <div className="input-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                </div>

                <span
                  className="position-absolute"
                  style={{
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  <i
                    className={`bi ${
                      showPassword ? "bi-eye-slash-fill" : "bi-eye-fill"
                    }`}
                  ></i>
                </span>
              </div>

              <div className="mb-3">
                <button
                  className={`explore-btn`}
                  disabled={
                    !formData.fullname ||
                    !formData.fullname ||
                    !formData.password ||
                    !formData.phonenumber
                  }
                  onClick={() => handleRegister()}
                >
                  {loading ? "processing..." : "Create account"}
                </button>
              </div>
              <div className="row">
                <div className="col">
                  <button
                    className="btn btn-link p-0 small text-muted"
                    onClick={() => setStep(2)}
                  >
                    Already Registered? Login{" "}
                  </button>
                </div>
              </div>
            </>
          )}

          {step === 4 && (
            <>
              <h5 className="text-center mb-2">Verify your email</h5>
              <p className="text-muted text-center">
                {message
                  ? `${message}`
                  : `We’ve sent a verification code to ${formData.emailid}`}
              </p>

              <input
                type="text"
                className="form-control mb-3"
                placeholder="Enter 6-digit OTP"
                value={emailOtp}
                onChange={(e) => setEmailOtp(e.target.value)}
              />

              <button
                className={`explore-btn ${
                  emailOtp.length === 6
                    ? "btn-primary text-white"
                    : "btn-light text-muted"
                }`}
                disabled={emailOtp.length !== 6}
                onClick={verifyEmailOtp}
              >
                {loading ? "processing..." : "Verify"}
              </button>

              {/* 🔁 Resend OTP */}
              <div className="text-center mt-3">
                {resendTimer > 0 ? (
                  <small className="text-muted">
                    Resend OTP in {Math.floor(resendTimer / 60)}:
                    {String(resendTimer % 60).padStart(2, "0")}
                  </small>
                ) : (
                  <button
                    className="btn btn-link p-0"
                    disabled={resending}
                    onClick={handleResendOtp}
                  >
                    {resending ? "Resending..." : "Resend OTP"}
                  </button>
                )}
              </div>
            </>
          )}

          {step === 5 && (
            <>
              <h5 className="text-center mb-2"> Verify email</h5>

              <input
                type="text"
                className="form-control mb-3"
                placeholder="Enter Email"
                name="emailid"
                value={formData.emailid}
                onChange={handleChange}
              />

              <button
                className={`explore-btn ${
                  emailOtp.length === 6
                    ? "btn-primary text-white"
                    : "btn-light text-muted"
                }`}
                onClick={VerifyforgotPassword}
              >
                {loading ? "processing..." : "Submit"}
              </button>
              <div className="row">
                <div className="col">
                  <button
                    className="btn btn-link p-0 small text-muted"
                    onClick={() => setStep(2)}
                  >
                    back to login
                  </button>
                </div>
              </div>
            </>
          )}

          {step === 6 && (
            <>
              <p className="text-muted text-center">
                {message
                  ? `${message}`
                  : `We’ve sent a verification code to ${formData.emailid}`}
              </p>

              <input
                type="text"
                className="form-control mb-3"
                placeholder="Enter verify Otp"
                value={emailOtp}
                onChange={(e) => setEmailOtp(e.target.value)}
              />

              <button
                className={`explore-btn ${
                  emailOtp.length === 6
                    ? "btn-primary text-white"
                    : "btn-light text-muted"
                }`}
                disabled={emailOtp.length !== 6}
                onClick={VerifyforgotEmailOtp}
              >
                {loading ? "processing..." : "Verify"}
              </button>

              {/* 🔁 Resend OTP */}
              <div className="text-center mt-3">
                {resendTimer > 0 ? (
                  <small className="text-muted">
                    Resend OTP in {Math.floor(resendTimer / 60)}:
                    {String(resendTimer % 60).padStart(2, "0")}
                  </small>
                ) : (
                  <button
                    className="btn btn-link p-0"
                    disabled={resending}
                    onClick={ResendforgotOtp}
                  >
                    {resending ? "Resending..." : "Resend OTP"}
                  </button>
                )}
              </div>
            </>
          )}

          {step === 7 && (
            <>
              <h5 className="text-center mb-2"> Reset Password </h5>

              <input
                type="text"
                className="form-control mb-3"
                name="newPassword"
                placeholder="Enter New Password"
                value={formData.newPassword}
                onChange={handleChange}
              />

              <input
                type="text"
                className="form-control mb-3"
                name="confirmPassword"
                placeholder="Enter Confirm Password"
                value={formData.confirmPassword}
                onChange={handleChange}
              />

              <button
                className="btn-primary text-white"
                onClick={ResetUserPassword}
              >
                {loading ? "processing..." : "Submit"}
              </button>
            </>
          )}
        </Modal.Body>

        {/* Modal Footer */}
        <Modal.Footer className="flex-column">
          <p className="small text-muted mb-0">
            By signing in or creating an account, you accept our{" "}
            <a href="/terms-conditions" className="pe-1">
              Terms and Conditions
            </a>
            and
            <a href="/privacy-policy" className="ps-1">
              Privacy Policy
            </a>
            .
          </p>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AuthModal;
